import type { TabConfig } from "@/components/shared/UniversalDetailPage/types/detailPage";

// ============================================================================
// CONTACT DETAIL TABS CONFIGURATION
// ============================================================================

export const contactDetailTabs: TabConfig<any>[] = [
  // Core Information Group
  {
    id: "details",
    label: "Details",
    icon: "user",
    variant: "blue",
    group: "core",
    priority: 1,
    clientVisible: true,
    content: {
      type: "custom",
      customComponent: "ContactDetailsDisplay",
    },
  },
  {
    id: "timeline",
    label: "Timeline",
    icon: "activity",
    variant: "purple",
    group: "core",
    priority: 1.15,
    content: {
      type: "custom",
      customComponent: "ContactTimelineDisplay",
    },
  },
  {
    id: "emails",
    label: "Emails",
    icon: "mail",
    variant: "blue",
    group: "core",
    priority: 1.5,
    content: {
      type: "custom",
      customComponent: "ContactEmailsDisplay",
    },
  },
  {
    id: "company",
    label: "Company",
    icon: "building",
    variant: "red",
    group: "core",
    priority: 2,
    content: {
      type: "custom",
      customComponent: "ContactCompanyDisplay",
    },
  },
  {
    id: "deals",
    label: "Deals",
    icon: "briefcase",
    variant: "blue",
    group: "core",
    priority: 2.5,
    content: {
      type: "custom",
      customComponent: "ContactDealsDisplay",
    },
  },
  {
    id: "contracts",
    label: "Contracts",
    icon: "file-signature",
    variant: "blue",
    group: "core",
    priority: 2.75,
    content: {
      type: "custom",
      customComponent: "ContactContractsDisplay",
    },
  },
  // Activity Group
  {
    id: "tasks",
    label: "Tasks",
    icon: "check-square",
    variant: "green",
    group: "activity",
    priority: 1,
    content: {
      type: "custom",
      customComponent: "ContactTasksDisplay",
    },
  },
  {
    id: "history",
    label: "History",
    icon: "history",
    variant: "purple",
    group: "activity",
    priority: 1.5,
    // No `clientVisible`: a DELETE snapshot in an audit log can carry another
    // record's PII, so history is staff-only. The GET route enforces the same
    // thing with `isEmployeeRole` — the tab flag is not the security boundary.
    content: {
      type: "custom",
      customComponent: "ContactHistoryDisplay",
    },
  },
  {
    id: "tickets",
    label: "Tickets",
    icon: "ticket",
    variant: "orange",
    group: "activity",
    priority: 2,
    clientVisible: true,
    content: {
      type: "custom",
      customComponent: "ContactTicketsDisplay",
    },
  },
  {
    id: "time-entries",
    label: "Time Entries",
    icon: "clock",
    variant: "purple",
    group: "activity",
    priority: 2.5,
    clientVisible: true,
    content: {
      type: "custom",
      customComponent: "ContactTimeEntriesDisplay",
    },
  },
  {
    id: "recurring-transactions",
    label: "Recurring Transactions",
    icon: "repeat",
    variant: "blue",
    group: "activity",
    priority: 3,
    visible: (contact) => {
      // Only visible to admins - component will handle role check
      return true;
    },
    content: {
      type: "custom",
      customComponent: "ContactRecurringTransactionsDisplay",
    },
  },
  // Resources Group
  {
    id: "drive",
    label: "Drive",
    icon: "folder",
    variant: "blue",
    group: "resources",
    priority: 1,
    content: {
      type: "custom",
      customComponent: "ContactDriveDisplay",
    },
  },
  {
    id: "documentation",
    label: "Documentation",
    icon: "book",
    variant: "purple",
    group: "resources",
    priority: 2,
    visible: (contact) => {
      // Only show for admin/employee users - this will be handled by role check in the component
      return true; // The component itself will handle role-based visibility
    },
    content: {
      type: "custom",
      customComponent: "ContactDocumentationDisplay",
    },
  },
  // Integration Group
  {
    id: "quickbooks",
    label: "QuickBooks",
    icon: "dollar-sign",
    variant: "green",
    group: "integration",
    priority: 1,
    visible: (contact) => {
      // Only show for admin users - this will be handled by role check in the component
      return true; // The component itself will handle role-based visibility
    },
    content: {
      type: "custom",
      customComponent: "ContactQuickBooksDisplay",
    },
  },
];
